import React, { FC } from 'react';
import css from '../TemplatePage.scss';
import { Badge, BadgeProps, Heading, HeadingProps } from '@wix/design-system';
import { tabsByIdMapper } from '../../../utils/mappers';
import { DataHooks } from '../../../constants/dataHooks';
import { useTranslation } from '@wix/wix-i18n-config';

import { useSingleTemplateData } from '../../../hooks/useSingleTemplateData';
import classNames from 'classnames';

type PageHeaderTitleProps = {
  isStickyHeaderTitle?: boolean;
};
export const PageHeaderTitle: FC<PageHeaderTitleProps> = ({
  isStickyHeaderTitle = false,
}) => {
  const { template } = useSingleTemplateData();
  const { t } = useTranslation();
  const headingSize: Partial<HeadingProps> = {
    size: isStickyHeaderTitle ? 'medium' : 'extraLarge',
  };
  const badgeSize: Partial<BadgeProps> = {
    size: isStickyHeaderTitle ? 'tiny' : 'medium',
  };
  return (
    <div
      className={classNames(css.titleWrapper, {
        [css.stickyHeaderTitleWrapper]: isStickyHeaderTitle,
      })}
    >
      <Heading dataHook={DataHooks.TemplateTitle()} {...headingSize}>
        {template?.title}
      </Heading>
      <div className={css.badgeWrapper}>
        {template?.developmentTools?.map((devTool) => {
          return (
            <Badge
              key={devTool}
              dataHook={DataHooks.TemplateBadge()}
              {...badgeSize}
              uppercase
              className={classNames(css.badge, {
                [css.stickyHeaderBadge]: isStickyHeaderTitle,
              })}
            >
              {t(tabsByIdMapper[devTool]?.badgeTextKey as string)}
            </Badge>
          );
        })}
      </div>
    </div>
  );
};
